import React, { Component } from 'react';
import {
  Alert,
  Badge,
  Button,
  Card,
  CardHeader,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row } from 'reactstrap';
import { FilePond } from 'react-filepond';

class ApplicationDetail extends Component {
  state = {
    idBtnDisabled: false,
    securityPending: false,
    securityVerified: false
  }

  handleSecurityPending = (e) => {
    e.preventDefault();
    this.setState({ securityPending: true });
  }

  handleSecurityVerified = () => {
    this.setState(prevState => ({
      securityVerified: !prevState.securityVerified
    }));
  }

  handleBtnDisable = () => {
    this.setState({
      modal: false,
      idBtnDisabled: true
    });
  }

  render() {
    const { idBtnDisabled, securityPending, securityVerified } = this.state;

    return (
      <div className="page-dashboard">

        <Container fluid>

          <Row className="mb-3 align-items-center">
            <Col md={6} lg={6} className="text-center text-md-left">
              <h3 className="d-lg-flex mb-3 mb-md-0">Application ID: 2561435 &nbsp;&nbsp;
              <Badge color="info" className="mt-1 mt-lg-0">Pre-Approved</Badge></h3>
            </Col>
            <Col md={6} lg={6}>
              <Container className="p-0 d-md-none mobile-buttons" fluid>
                <Row noGutters>
                  <Col sm={6} md="auto" className="pl-3 pr-3 pr-sm-1 mb-1 mb-md-0">
                    <Button color="primary" tag="a" href="/application/select-offer" className="w-100">Select Offer</Button>
                  </Col>
                </Row>
              </Container>
              <Container className="p-0 d-none d-md-block" fluid>
                <Row className="flex-md-row justify-content-end" noGutters>
                  <Col sm={6} md="auto" className="pl-sm-1 mb-1 mb-sm-0">
                    <Button color="primary" size="sm" tag="a" href="/application/select-offer" className="w-100">Select Offer</Button>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

          <Row>
            <Col md={6} lg={4}>

              <Card>
                <CardHeader>Personal Information</CardHeader>
                <CardBody>
                  <Form>
                    <FormGroup>
                      <Label for="firstName">First Name</Label>
                      <Input type="text" name="first-name" id="firstName" defaultValue="Kyle" />
                    </FormGroup>
                    <FormGroup>
                      <Label for="lastName">Last Name</Label>
                      <Input type="text" name="last-name" id="lastName" defaultValue="McConnell" />
                    </FormGroup>
                    <Row form>
                      <Col xs="12" xl="6">
                        <FormGroup>
                          <Label for="SSN">Last 4 of SSN</Label>
                          <Input type="text" name="ssn" id="SSN" defaultValue="4321" />
                        </FormGroup>
                      </Col>
                      <Col xs="12" xl="6">
                        <FormGroup>
                          <Label for="DOB">Date of Birth</Label>
                          <Input type="text" name="dob" id="DOB" defaultValue="09/08/1943" />
                        </FormGroup>
                      </Col>
                    </Row>
                    <FormGroup>
                      <Label for="Email">Email Address</Label>
                      <Input type="text" name="email" id="Email" defaultValue="kylefoundry@gmail.com" />
                    </FormGroup>
                    <FormGroup className="mb-0">
                      <Label for="cellPhone">Cell Phone</Label>
                      <Input type="text" name="cell-phone" id="cellPhone" defaultValue="(321) 456-7890" />
                    </FormGroup>
                  </Form>
                </CardBody>
              </Card>

            </Col>
            <Col md={6} lg={4}>

              <Card>
                <CardHeader>Borrower Address</CardHeader>
                <CardBody>
                  <p>Address of the primary borrower</p>
                  <Form>
                    <FormGroup>
                      <Label for="Address">Address</Label>
                      <Input type="text" name="address" id="Address" defaultValue="1020 W Lawrence Ave" />
                    </FormGroup>
                    <FormGroup>
                      <Label for="City">City</Label>
                      <Input type="text" name="city" id="City" defaultValue="Chicago" />
                    </FormGroup>
                    <Row form>
                      <Col md={8}>
                        <FormGroup>
                          <Label for="State">State</Label>
                          <Input type="text" name="state" id="State" defaultValue="Illinois" />
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="Zip">Zip</Label>
                          <Input type="text" name="zip" id="Zip" defaultValue="60640" />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>

            </Col>
            <Col md={6} lg={4}>

              <Card className="border-primary">
                <CardHeader>ID Verification</CardHeader>
                <CardBody className="text-center">
                  <Row>
                    <Col>
                      <h5 className="mb-2">ID Upload - Front</h5>
                      <FilePond />
                    </Col>
                    <Col>
                      <h5 className="mb-2">ID Upload - Back</h5>
                      <FilePond />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} className="mb-2">
                      <small><strong>–&nbsp;&nbsp; OR &nbsp;&nbsp;–</strong></small>
                    </Col>
                    <Col sm={12}>
                      <Button
                        className="w-100 mb-1"
                        color="secondary"
                        >
                        Request ID Via Text
                      </Button>
                    </Col>

                    { securityPending ?
                      securityVerified ?
                        <Col sm={12}>
                          <Alert color="danger" className="mt-1 mb-0">
                            <strong>Verification failed.</strong> Please call<br /> 877-203-4747 to verify.
                          </Alert>
                        </Col>
                      :
                        <Col sm={12}>
                          <Alert color="success" className="mt-1 mb-0" onClick={this.handleSecurityVerified}>
                            <strong>ID Successfully Verified</strong>
                          </Alert>
                        </Col>
                    :
                      <Col sm={12}>
                        <Button
                          className="w-100 mt-1"
                          color="primary"
                          onClick={this.handleSecurityPending}
                          disabled={idBtnDisabled}
                          >
                          Check ID Status
                        </Button>
                      </Col>
                    }

                  </Row>
                </CardBody>
              </Card>

            </Col>
          </Row>

        </Container>

      </div>
    );
  }
}

export default ApplicationDetail;
